import AboutSection from './Components/AboutSection';
import AreasWeServe from './Components/AreasWeServe';
import Banner from './Components/Banner';
import CoachIntroSection from './Components/CoachIntroSection';
import CoachIntroSection2 from './Components/CoachIntroSection2';
import FaqAccordion from './Components/FaqAccordion';

import Footer from './Components/Footer';
   import FutureSelf from './Components/FutureSelf';
import GoogleReviewsWidget from './Components/GoogleReviewsWidget';
import MeetLeadership from './Components/leaders';
import LifeAtOmSai from './Components/LifeAtOmSai';
import LogoSlider from './Components/LogoSlider';
import OmSaiTeamSection from './Components/OmSaiTeamSection';


function App() {
  return (
    <div className="App">
      <Banner/>
      <AboutSection/>
      <FutureSelf/>
      <AreasWeServe/>
      <CoachIntroSection/>
      <CoachIntroSection2/>
      <MeetLeadership/>
      <LogoSlider/>
      <GoogleReviewsWidget/>
      <LifeAtOmSai/>
      <OmSaiTeamSection/>
      <FaqAccordion/>
      <Footer/> 
      
    </div>
  );
}

export default App;
